import { render } from "./set_property.vue?vue&type=template&id=3dbd51a8"
import script from "./set_property.vue?vue&type=script&lang=js"
export * from "./set_property.vue?vue&type=script&lang=js"

import "./set_property.vue?vue&type=style&index=0&id=3dbd51a8&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_pms_web\\pms_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__